import { render, staticRenderFns } from "./IntegrationRecord.vue?vue&type=template&id=3c4c0bc2&scoped=true"
import script from "./IntegrationRecord.vue?vue&type=script&lang=js"
export * from "./IntegrationRecord.vue?vue&type=script&lang=js"
import style0 from "./IntegrationRecord.vue?vue&type=style&index=0&id=3c4c0bc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4c0bc2",
  null
  
)

export default component.exports